import {yupResolver} from '@hookform/resolvers/yup';
import Fuse from 'fuse.js';
import moment from 'moment';
import React, {useEffect, useState} from 'react';
import {
  FormProvider,
  SubmitErrorHandler,
  SubmitHandler,
  useForm,
} from 'react-hook-form';
import {
  FlatList,
  SafeAreaView,
  Text,
  TextInput as TextInput1,
  TouchableOpacity,
  View,
} from 'react-native';
import Icon from '@react-native-vector-icons/fontawesome';
import {useSelector} from 'react-redux';
import * as yup from 'yup';
import {ShowToast} from '../Common/common';
import BTButton from '../Components/BTButton';
import BTComboBox from '../Components/BTComboBox';
import {BTDateTimePicker} from '../Components/BTDateTimePicker';
import {Col, Row} from '../Components/BTGrid';
import {TextInput} from '../Components/BTTextInput';
import {useGetModesQuery} from '../redux/services/amodeApi';
import {
  useInsertPurchaseMutation,
  useUpdatePurchaseMutation,
} from '../redux/services/stepurchaseApi';
import {
  useGetPurchaseorderByPendingQuery,
  useLazyGetPurchaseorderQuery,
} from '../redux/services/stepurchaseorderApi';
import {useGetSTMGroupsQuery} from '../redux/services/stmgroupApi';
import {useGetSTMProductsQuery} from '../redux/services/stmproductApi';
import {useGetSuppliersQuery} from '../redux/services/stmsupplierApi';
import {useGetSTAMStoresQuery} from '../redux/services/stamstoreApi';
import TasmacScanModal, {TasmacApplyPayload} from '../Components/TasmacScanModal';
import {RootState} from '../redux/store';
import styles from '../styles/Styles';

import T from '../Components/T';
import { tp } from '../utils/translateText';
interface item {
  pr_group?: number;
  pr_id: number;
  pr_name?: string;
  pr_srate: number;
  pr_qty: number;
  pr_nameed: boolean;
  value: st_mproduct;
}

interface Quantities {
  [key: string]: {
    descr: string;
    quantity: number;
    rate: number;
    remarks: string;
    nameed: boolean;
    // Exact line amount from a scanned invoice (rate x qty would round); cleared when qty or rate is edited.
    amount?: number;
  };
}

const validationSchema = yup.object().shape({
  pu_supp: yup
    .number()
    .required()
    .typeError('Select Supplier?')
    .min(1, 'Select Supplier'),
});

const STPurchaseOrder = ({navigation, route}: UniversalProps) => {
  const gdata: any = useSelector((state: RootState) => state.gdata);
  const [search, setSearch] = useState('');
  const [group, setGroup] = useState(0);
  const [cart, setCart] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [quantities, setQuantities] = useState<Quantities>({});
  // TASMAC invoice scan: modal, destination store and invoice-level charges.
  const [scanOpen, setScanOpen] = useState(false);
  const [scanStore, setScanStore] = useState(0);
  const [charges, setCharges] = useState({tcs: 0, other: 0, roundOff: 0});

  const cid = gdata.company;

  const {data: modeData} = useGetModesQuery(cid);
  const {data: suppData} = useGetSuppliersQuery(cid);
  const {data: storeData} = useGetSTAMStoresQuery(cid);
  const {data, refetch} = useGetSTMProductsQuery(gdata.company);
  const {data: poData} = useGetPurchaseorderByPendingQuery(cid, {
    refetchOnFocus: true,
  });

  useEffect(() => {
    refetch();
  }, []);

  const {data: groupData} = useGetSTMGroupsQuery(gdata.company);

  const pos: any = poData?.map((value, key) => {
    return {
      label: value.po_name + ' - ' + value.po_no,
      id: value.po_id,
      value: value,
    };
  });

  const supps: any = suppData?.map((value, key) => {
    return {
      label: value.sp_name,
      id: value.sp_id,
      values: value,
    };
  });

  const scanStores: any[] = (storeData || []).filter((s: any) => s.sm_flag === '1');
  const mainStoreId = Number(scanStores.find((s: any) => s.sm_code === 'MAIN')?.sm_id) || 0;

  const groups: any = groupData?.map((value, _key) => {
    return {
      label: value.gr_name,
      id: value.gr_id,
      values: value,
    };
  });

  const products1: any = data?.map((value: any, _key: any) => {
    return {
      pr_group: value.pr_group,
      pr_id: value.pr_id,
      pr_name: value.pr_name,
      pr_srate: value.pr_srate,
      pr_qty: 0,
      pr_grname: value.pr_grname,
      pr_nameed: value.pr_name == '',
      value: value,
    };
  });

  const renderSeparator = () => {
    return (
      <View
        style={{
          height: 1,
          width: '86%',
          backgroundColor: '#CED0CE',
          marginLeft: '14%',
        }}
      />
    );
  };

  const handleCart = (item: item, qty: number) => {
    const rate =
      Number(item.pr_srate) > 0
        ? Number(item.pr_srate)
        : Number(quantities[item.pr_id]?.rate) || 0;

    // Don't add if rate is 0 and user hasn't entered one yet (only when
    // adding quantity, not removing) - otherwise an undefined/NaN rate
    // silently reaches pd_rate in the submitted purchase.
    if (rate <= 0 && qty > 0 && Number(item.pr_srate) === 0) {
      ShowToast('Please enter rate first', 'error');
      return;
    }

    if ((quantities[item.pr_id]?.quantity || 0) + qty >= 0) {
      const amt = ((quantities[item.pr_id]?.quantity || 0) + qty) * rate;

      setQuantities({
        ...quantities,
        [item.pr_id]: {
          descr: item.pr_name,
          quantity: (Number(quantities[item.pr_id]?.quantity) || 0) + qty,
          rate: rate,
          nameed: item.pr_nameed,
        },
      });
    } else {
      const newQuantities = {...quantities};
      delete newQuantities[item.pr_id];

      setQuantities(newQuantities);
    }
  };

  const handleCartClick = () => {
    setCart(!cart);

    setGroup(0);
    setSearch('');
  };

  const [products, setProducts] = useState(products1);

  useEffect(() => {
    const prods = products1?.filter((v: any) => {
      return Number(v.pr_group) == Number(group) || Number(group) == 0;
    });

    if (search !== '' && !isNaN(parseFloat(search)) && !cart) {
      const d = products1.filter((o: any) => o.value.pr_code == search);
      setProducts(d);
    } else if (search.length >= 3 && !cart) {
      const options = {
        includeScore: true,
        useExtendedSearch: true,
        keys: ['pr_name'],
      };

      const fuse = new Fuse(prods, options);
      const b = fuse.search(search);
      const c = b.map(v => {
        return v.item;
      });

      setProducts(c);
    } else if (search == '') {
      setProducts(
        prods?.filter((v: any) => {
          return (quantities?.hasOwnProperty(v.pr_id) && cart) || !cart;
        }),
      );
    }
  }, [search, data, cart, group]);

  let initialValues: any = {
    pu_id: 0,
    pu_company: cid,
    pu_date:
      moment(gdata.today).format('YYYY/MM/DD') + moment().format(' HH:mm:ss'),
    pu_poid: 0,
    pu_no: '',
    pu_supp: '',
    pu_name: '',
    pu_address: '',
    pu_state: gdata.defstate,
    pu_country: gdata.defcountry,
    pu_taxno: '',
    pu_invno: '',
    pu_invdt: moment().toDate(),
    pu_amt: '',
    pu_remarks: '',
    pu_flag: '1',
    pu_uid: gdata.user,
    pu_cdt: moment().format('YYYY/MM/DD HH:mm:ss'),
    pu_muid: gdata.user,
    pu_mdt: moment().format('YYYY/MM/DD HH:mm:ss'),
    pu_details: [],
    pu_modes: [],
  };

  const {...methods} = useForm<any>({
    defaultValues: initialValues,
    resolver: yupResolver(validationSchema),
  });

  const [lazyGetPurchaseorder] = useLazyGetPurchaseorderQuery();

  const [insertPurchase] = useInsertPurchaseMutation();
  const [updatePurchase] = useUpdatePurchaseMutation();

  const onSubmit: SubmitHandler<st_epurchase> = async values => {
    if (isSaving) {
      return;
    }

    try {
      let itms: st_epurchasedetails[] = [];
      let i = 1;
      for (const [id, product] of Object.entries(quantities)) {
        const {descr, quantity, rate, remarks} = product;

        if (quantity > 0)
          itms.push({
            pd_id: 0,
            pd_srid: i++,
            pd_prod: Number(id),
            pd_descr: descr,
            pd_qty: quantity,
            pd_rate: rate,
            pd_uom: 1,
            pd_discper: 0,
            pd_discamt: 0,
            pd_tax1: 0,
            pd_tax1per: 0,
            pd_tax1amt: 0,
            pd_tax2: 0,
            pd_tax2per: 0,
            pd_tax2amt: 0,
            pd_tax3: 0,
            pd_tax3per: 0,
            pd_tax3amt: 0,
            pd_amount:
              product.amount !== undefined
                ? Number(product.amount)
                : Number(quantity) * Number(rate),
          });
      }
      values.pu_details = itms;
      if (scanStore) {
        // From a TASMAC scan: purchase into the chosen (bar) store, with the invoice charges; the per-ml cost
        // must not overwrite the item's sale rate.
        (values as any).pu_store = scanStore;
        (values as any).pu_tcs = charges.tcs;
        (values as any).pu_othercharges = charges.other;
        (values as any).pu_roundoff = charges.roundOff;
        (values as any).pu_skipsalerate = true;
      }
      values.pu_date = new Date();

      if (values.pu_details.length === 0) {
        ShowToast('Select Menu Items', 'error');

        return;
      }
      setIsSaving(true);

      if (Number(values.pu_id) !== 0) {
        const dat: any = await updatePurchase(values).unwrap();

        methods.reset();

        ShowToast(dat.pu_no + ' Updated Sucessfully');
      } else {
        const dat: any = await insertPurchase(values).unwrap();

        methods.reset();
        ShowToast(dat.pu_no + ' Saved Sucessfully');
      }

      setIsSaving(false);
      navigation.goBack();
    } catch (e: any) {
      ShowToast(e?.data?.message || e?.message || 'Failed to save purchase', 'error');
      setIsSaving(false);
    }
  };

  const onError: SubmitErrorHandler<st_epurchase> = (errors, e) => {
    Object.keys(errors).map((fieldName: string, i: number) => {
      // Handle form errors
    });
    return false;
  };

  const [billfooter, setBillfooter] = useState({
    stotqty: '0.00',
    stotamt: '0.00',
  });

  const CalcTot = () => {
    let totQty = 0,
      totAmt = 0;
    for (const [_id, product] of Object.entries(quantities)) {
      const {quantity, rate} = product;

      if (Number(quantity) > 0) {
        totQty += Number(quantity);
        totAmt +=
          product.amount !== undefined
            ? Number(product.amount)
            : Number(rate) * Number(quantity);
      }
    }
    totAmt += charges.tcs + charges.other + charges.roundOff;
    totAmt = Math.round(totAmt * 100) / 100;
    methods.setValue('pu_amt', totAmt);
    setBillfooter({
      stotqty: totQty.toFixed(2),
      stotamt: totAmt.toFixed(2),
    });
    methods.setValue('pu_modes', [
      {
        pm_id: 0,
        pm_srid: 1,
        pm_mode: 0,
        pm_refno: '',
        pm_refdt: new Date(),
        pm_bank: '',
        pm_amt: totAmt,
      },
    ]);
  };

  useEffect(() => {
    CalcTot();
  }, [quantities, charges]);

  const updateItemField = (field: string, text: string, itemId: string) => {
    setQuantities(prevQuantities => {
      const currentItem = prevQuantities[itemId] || {
        quantity: 0,
        remarks: '',
        descr: '',
        rate: 0,
        nameed: true,
      };

      const updatedItem: any = {
        ...currentItem,
        [field]: text,
      };
      // A hand edit of qty or rate replaces the scanned exact amount.
      if (field === 'quantity' || field === 'rate') {
        delete updatedItem.amount;
      }

      return {
        ...prevQuantities,
        [itemId]: updatedItem,
      };
    });
  };

  const applyScan = ({result, supplierId, storeId, lines}: TasmacApplyPayload) => {
    const sup: any = suppData?.find((x: any) => x.sp_id === supplierId);
    if (sup) {
      methods.setValue('pu_supp', sup.sp_id);
      methods.setValue('pu_name', sup.sp_name);
      methods.setValue('pu_address', sup.sp_address || 'Nill');
      methods.setValue('pu_state', sup.sp_state || 0);
      methods.setValue('pu_country', sup.sp_country || 0);
    }
    methods.setValue('pu_taxno', sup?.sp_taxno || result.supplier?.gstin || '');
    if (result.invoice?.no) {
      methods.setValue('pu_invno', result.invoice.no);
    }
    if (result.invoice?.date) {
      methods.setValue('pu_invdt', moment(result.invoice.date).toDate());
    }
    const q: Quantities = {};
    lines.forEach(l => {
      q[String(l.productId)] = {
        descr: l.name,
        quantity: l.qty,
        rate: l.rate,
        remarks: '',
        nameed: false,
        amount: l.amount,
      };
    });
    setScanStore(storeId);
    setCharges({
      tcs: result.charges?.tcs || 0,
      other: result.charges?.otherCharges || 0,
      roundOff: result.charges?.roundOff || 0,
    });
    setQuantities(q);
    setCart(true);
    setScanOpen(false);
  };

  const renderItem = (item: any) => {
    return item ? (
      <View style={styles.conLstItem} key={item.pr_id}>
        <View style={styles.conLstData}>
          {group == 0 ? (
            <Row>
              <Col>
                <Text style={styles.descr}>{item?.pr_grname}</Text>
              </Col>
            </Row>
          ) : null}
          <Row>
            <Col>
              {item?.pr_nameed && quantities[item.pr_id]?.quantity > 0 ? (
                <FormProvider {...methods}>
                  <TextInput
                    name={`descr.${item.pr_id}`}
                    label=""
                    placeholder={tp("Product Name")}
                    onChangeText={txt =>
                      updateItemField('descr', txt, item.pr_id)
                    }
                  />
                </FormProvider>
              ) : (
                <Text style={styles.heading}>
                  {item?.pr_name} <T>@ Rs.</T>{item?.pr_srate}
                </Text>
              )}
            </Col>
          </Row>

          <Row style={styles.rowSec}>
            <Col>
              <FormProvider {...methods}>
                <TextInput
                  name={`rate.${item.pr_id}`}
                  label=""
                  placeholder={tp("Rate")}
                  value={quantities[item.pr_id]?.rate.toString()}
                  onChangeText={txt => updateItemField('rate', txt, item.pr_id)}
                  keyboardType="numeric"
                />
              </FormProvider>
            </Col>
            <Col style={styles.iconCol}>
              <TouchableOpacity
                onPress={() => handleCart(item, -1)}
                style={{
                  backgroundColor: '#FF6B6B',
                  padding: 1,
                  borderRadius: 50,
                  shadowColor: '#000',
                  shadowOffset: {width: 0, height: 4},
                  shadowOpacity: 0.3,
                  shadowRadius: 4,
                  elevation: 6,
                }}>
                <Icon
                  name="minus-circle"
                  size={42}
                  color="#FFF"
                  style={{alignSelf: 'center'}}
                />
              </TouchableOpacity>
            </Col>
            <Col>
              <Text style={styles.qty}>
                <FormProvider {...methods}>
                  <TextInput
                    name={`quantity.${item.pr_id}`}
                    label=""
                    placeholder={tp("Qty")}
                    value={quantities[item.pr_id]?.quantity.toString()}
                    onChangeText={txt =>
                      updateItemField('quantity', txt, item.pr_id)
                    }
                    keyboardType="numeric"
                    style={styles.qty}
                  />
                </FormProvider>
              </Text>
            </Col>
            <Col style={styles.iconCol}>
              <TouchableOpacity
                onPress={() => handleCart(item, 1)}
                style={{
                  backgroundColor: '#28A745',
                  padding: 1,
                  borderRadius: 50,
                  shadowColor: '#000',
                  shadowOffset: {width: 0, height: 4},
                  shadowOpacity: 0.3,
                  shadowRadius: 4,
                  elevation: 6,
                }}>
                <Icon
                  name="plus-circle"
                  size={42}
                  color="#FFF"
                  style={{alignSelf: 'center'}}
                />
              </TouchableOpacity>
            </Col>
            <Col>
              <Text style={styles.amt}>
                {'Rs.' +
                  (!isNaN(Number(quantities[item.pr_id]?.quantity)) &&
                  !isNaN(Number(quantities[item.pr_id]?.rate))
                    ? quantities[item.pr_id]?.rate *
                      quantities[item.pr_id]?.quantity
                    : 0)}
              </Text>
            </Col>
          </Row>
        </View>
      </View>
    ) : (
      <View />
    );
  };

  const [showHead, setShowHead] = useState(true);

  return (
    <View style={styles.app}>
      {/* Modern Header */}
      <View style={styles.modernHeaderContainer}>
        <Text style={styles.modernHeaderTitle}><T>Purchase</T></Text>
      </View>

      <FormProvider {...methods}>
        {showHead ? (
            <>
              <Row>
                <Col>
                  <BTComboBox
                    name="pu_poid"
                    label="Purchase Order"
                    data={pos}
                    placeholder={tp("Purchase Order")}
                    onValChange={async (v: any) => {
                      setCart(false);
                      const val = await lazyGetPurchaseorder(v);

                      if (val.data) {
                        methods.setValue('pu_supp', val.data.po_supp);
                        methods.setValue('pu_name', val.data.po_name);
                        methods.setValue('pu_address', val.data.po_address);
                        methods.setValue('pu_state', val.data.po_state);
                        methods.setValue('pu_country', val.data.po_country);
                        methods.setValue('pu_taxno', val.data.po_taxno);
                        methods.setValue('pu_amt', val.data.po_amt);
                        methods.setValue('pu_details', []);
                        methods.setValue('pu_details', val.data.po_details);
                        setQuantities(
                          val.data.po_details.reduce(
                            (acc, v) => ({
                              ...acc,
                              [v.pd_prod.toString()]: {
                                descr: v.pd_descr,
                                quantity: v.pd_qty,
                                rate: v.pd_rate,
                                remarks: '',
                                nameed: false,
                              },
                            }),
                            {},
                          ),
                        );
                      }

                      CalcTot();
                      setShowHead(false);
                      setCart(true);
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <BTComboBox
                    name="pu_supp"
                    label="Supplier"
                    data={supps}
                    placeholder={tp("Supplier")}
                    onValChange={(v: any) => {
                      methods.setValue(
                        'pu_name',
                        supps?.find(
                          (v: any) => v.id == methods.getValues('pu_supp'),
                        )?.label || 'Nill',
                      );
                      methods.setValue(
                        'pu_address',
                        supps?.find(
                          (v: any) => v.id == methods.getValues('pu_supp'),
                        )?.sp_address || 'Nill',
                      );
                      methods.setValue(
                        'pu_state',
                        supps?.find(
                          (v: any) => v.id == methods.getValues('pu_supp'),
                        )?.sp_state || 0,
                      );
                      methods.setValue(
                        'pu_country',
                        supps?.find(
                          (v: any) => v.id == methods.getValues('pu_supp'),
                        )?.sp_country || 0,
                      );
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <TextInput
                    name="pu_invno"
                    label="Invoice No"
                    placeholder={tp("Invoice No")}
                  />
                </Col>
                <Col>
                  <BTDateTimePicker
                    name="pu_invdt"
                    label="Invoice Date"
                    mode="date"
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <TextInput
                    name="pu_remarks"
                    label="Remarks"
                    placeholder={tp("Remarks")}
                  />
                </Col>
              </Row>
            </>
          ) : null}
          <Row>
            <Col>
              <View style={styles.button}>
                <BTButton
                  title="Scan TASMAC Invoice"
                  color="#19A7CE"
                  onPress={() => setScanOpen(true)}
                  onLongPress={() => {}}
                  disabled={isSaving}
                />
              </View>
            </Col>
          </Row>
          <Row>
            <Col>
              <View style={styles.button}>
                <BTButton
                  title="Save"
                  color="#146C94"
                  onPress={methods.handleSubmit(onSubmit, onError)}
                  onLongPress={() => {}}
                  disabled={isSaving}
                />
              </View>
            </Col>
            <Col>
              <View style={styles.button}>
                <BTButton
                  title="Clear"
                  color="#146C94"
                  onPress={() => {
                    methods.reset();
                    setQuantities({});
                    setScanStore(0);
                    setCharges({tcs: 0, other: 0, roundOff: 0});
                  }}
                  onLongPress={() => {}}
                  disabled={isSaving}
                />
              </View>
            </Col>
            <Col>
              <View style={styles.button}>
                <BTButton
                  title="View"
                  color={cart ? '#19A7CE' : '#146C94'}
                  onPress={() => handleCartClick()}
                  onLongPress={() => {}}
                  disabled={isSaving}
                />
              </View>
            </Col>
            <Col>
              <View style={styles.button}>
                <BTButton
                  title={`${
                    showHead
                      ? 'hide'
                      : supps
                          ?.find(
                            (v: any) => v.id == methods.getValues('pu_supp'),
                          )
                          ?.label?.slice(0, 4) || 'Nill'
                  }`}
                  onLongPress={() => {}}
                  color={showHead ? '#19A7CE' : '#146C94'}
                  onPress={() => setShowHead(prev => !prev)}
                  disabled={isSaving}
                />
              </View>
            </Col>
          </Row>
          {cart ? (
            <View style={{padding: 10}}>
              <Row>
                <Col>
                  <Text style={styles.heading}><T>Name</T></Text>
                </Col>
                <Col>
                  <Text>{methods.getValues('pu_name')}</Text>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Text style={styles.heading}><T>Address</T></Text>
                </Col>
                <Col>
                  <Text>{methods.getValues('pu_address')}</Text>
                </Col>
              </Row>
              {scanStore ? (
                <Row>
                  <Col>
                    <Text style={styles.heading}>
                      <T>TCS / Other / Round off</T>
                    </Text>
                  </Col>
                  <Col>
                    <Text>
                      {charges.tcs.toFixed(2)} / {charges.other.toFixed(2)} / {charges.roundOff.toFixed(2)}
                    </Text>
                  </Col>
                </Row>
              ) : null}
              <Row>
                <Col>
                  <Text style={styles.heading}><T>Total Amount</T></Text>
                </Col>
                <Col>
                  <Text>{billfooter.stotqty}</Text>
                </Col>
                <Col>
                  <Text style={[styles.amt, styles.heading]}>
                    {billfooter.stotamt}
                  </Text>
                </Col>
              </Row>
            </View>
          ) : null}
          {cart ? null : (
            <Row>
              <Col>
                <BTComboBox
                  name="group"
                  label="Group"
                  data={groups}
                  placeholder={tp("Select Group")}
                  onValChange={(v: any) => setGroup(v)}
                />
              </Col>
            </Row>
          )}
        </FormProvider>
      {cart ? null : (
        <Row>
          <Col>
            <TextInput1
              style={styles.text}
              onChangeText={setSearch}
              value={search}
              placeholder={tp("Search")}
            />
          </Col>
        </Row>
      )}
      <View style={{flex: 1}}>
        <FlatList
          ItemSeparatorComponent={renderSeparator}
          data={products}
          renderItem={({item}) => renderItem(item)}
          onEndReachedThreshold={0.1}
          contentContainerStyle={{paddingBottom: 80}}
          keyboardShouldPersistTaps="handled"
        />
      </View>
      <TasmacScanModal
        visible={scanOpen}
        onClose={() => setScanOpen(false)}
        suppliers={(supps || []).map((x: any) => ({id: x.id, label: x.label}))}
        products={(data || []).map((x: any) => ({pr_id: x.pr_id, pr_name: x.pr_name}))}
        stores={scanStores}
        defaultStoreId={scanStore || mainStoreId}
        onApply={applyScan}
      />
    </View>
  );
};

export default STPurchaseOrder;

